<template>
  <div id="recomd-lens">
    <table class="table-border" style="width: 100%">
      <tr>
        <td class="table-data">
          <ContenctLensTable
            :title="inputData1Title"
            :inputList="lists.inputList1"
            :outputList="lists.outputList1"
            calFunc="contactLensRecommend1"
          />
        </td>
        <td class="table-data">
          <ContenctLensTable
            :title="inputData2Title"
            :inputList="lists.inputList2"
            :outputList="lists.outputList2"
            calFunc="contactLensRecommend2"
          />
        </td>
      </tr>
      <tr>
        <td class="table-data">
          <ContenctLensTable
            :title="inputData3Title"
            :inputList="lists.inputList3"
            :outputList="lists.outputList3"
            calFunc="contactLensRecommend3"
          />
        </td>
        <td class="table-data">
          <ContenctLensTable
            :title="inputData4Title"
            :inputList="lists.inputList4"
            :outputList="lists.outputList4"
            calFunc="contactLensRecommend4"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import ContenctLensTable from "./ContenctLensTable";
import { paramNormal } from "../../shared/filters";
import { INVALID_1000, MAJMEDIANMODES, hasKey, getKey } from "../shared";
import DataParams from "../dataGetters/params";
import { getPupilCorneadiaKey } from "../../shared/utils";
const FORMAT_OPT = { fixed: 2, rpText: "" };

export default {
  name: "RGP-RecomContactLens",
  props: {
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      lists: {
        inputList1: [
          { key: "inputlist1-ds", label: this.$t("langcfg.txtSphS"), val: "" },
          { key: "inputlist1-dc", label: this.$t("langcfg.txtCylC"), val: "" },
          { key: "inputlist1-flatK", label: this.$t("langcfg.txtFlatkD"), val: "" },
          { key: "inputlist1-steepK", label: this.$t("langcfg.txtSteepkD"), val: "" },
          { key: "inputlist1-meanK", label: this.$t("langcfg.txtAvgkD"), val: "" },
          { key: "inputlist1-w2w", label: this.$t("langcfg.txtW2W"), val: "" }
        ],
        outputList1: [
          { key: "outputlist1-basic-arc ", label: this.$t("langcfg.txtBaseArc"), val: "" },
          { key: "outputlist1-luminosity", label: this.$t("langcfg.txtDiopter"), val: "" },
          { key: "outputlist1-dia", label: this.$t("langcfg.txtDiaUnit"), val: "" }
        ],
        inputList2: [
          { key: "inputlist2-ds", label: this.$t("langcfg.txtSphS"), val: "" },
          { key: "inputlist2-dc", label: this.$t("langcfg.txtCylC"), val: "" },
          { key: "inputlist2-flatK", label: this.$t("langcfg.txtFlatkD"), val: "" },
          { key: "inputlist2-steepK", label: this.$t("langcfg.txtSteepkD"), val: "" },
          { key: "inputlist2-w2w", label: this.$t("langcfg.txtW2W"), val: "" }
        ],
        outputList2: [
          { key: "outputlist2-basic-arc ", label: this.$t("langcfg.txtBaseArc"), val: "" },
          { key: "outputlist2-luminosity", label: this.$t("langcfg.txtDiopter"), val: "" },
          { key: "outputlist2-dia", label: this.$t("langcfg.txtDiaUnit"), val: "" }
        ],
        inputList3: [
          { key: "inputlist3-ds", label: this.$t("langcfg.txtSphS"), val: "" },
          { key: "inputlist3-dc", label: this.$t("langcfg.txtCylC"), val: "" },
          { key: "inputlist3-flatK", label: this.$t("langcfg.txtFlatkD"), val: "" },
          { key: "inputlist3-steepK", label: this.$t("langcfg.txtSteepkD"), val: "" },
          { key: "inputlist3-flat-simK", label: this.$t("langcfg.txtFlatSimkD"), val: "" },
          { key: "inputlist3-e", label: this.$t("langcfg.txtEccVal"), val: "" },
          { key: "inputlist3-w2w", label: this.$t("langcfg.txtW2W"), val: "" }
        ],
        outputList3: [
          { key: "outputList3-flat-basic-arc", label: this.$t("langcfg.txtFlatBaseArc"), val: "" },
          {
            key: "outputList3-steep-basic-arc",
            label: this.$t("langcfg.txtSteepBaseArc"),
            val: ""
          },
          { key: "outputList3-luminosity", label: this.$t("langcfg.txtDiopter"), val: "" },
          { key: "outputList3-dia", label: this.$t("langcfg.txtDiaUnit"), val: "" }
        ],

        inputList4: [
          { key: "inputList4-ds", label: this.$t("langcfg.txtSphS"), val: "" },
          { key: "inputlist1-dc", label: this.$t("langcfg.txtCylC"), val: "" },
          { key: "inputlist1-flatK", label: this.$t("langcfg.txtFlatkD"), val: "" },
          { key: "inputlist1-steepK", label: this.$t("langcfg.txtSteepkD"), val: "" },
          { key: "inputlist1-flat-simK", label: this.$t("langcfg.txtFlatSimkD"), val: "" },
          { key: "inputlist1-steep-simK", label: this.$t("langcfg.txtSteepSimk"), val: "" },
          { key: "inputlist1-flatE", label: this.$t("langcfg.txtFlatE"), val: "" },
          { key: "inputlist1-steepE", label: this.$t("langcfg.txtSteepE"), val: "" },
          { key: "inputlist1-w2w", label: this.$t("langcfg.txtW2W"), val: "" }
        ],

        outputList4: [
          { key: "outputList4-flatBC", label: this.$t("langcfg.txtFlatBaseArc"), val: "" },
          { key: "outputList4-steepBC", label: this.$t("langcfg.txtSteepBaseArc"), val: "" },
          { key: "outputList4-flatLuminosity", label: this.$t("langcfg.txtFlatDiopter"), val: "" },
          {
            key: "outputList4-steepLuminosity ",
            label: this.$t("langcfg.txtSteepDiopter"),
            val: ""
          },
          { key: "outputList4-dia", label: this.$t("langcfg.txtDiaUnit"), val: "" }
        ]
      }
    };
  },
  components: {
    ContenctLensTable
  },
  mounted() {
    this.loadDefaultValue();
  },
  methods: {
    loadDefaultValue() {
      let meanEcc = this.getMeanEcc();
      let w2w = this.getW2w();
      let allinput = [
        this.lists.inputList1,
        this.lists.inputList2,
        this.lists.inputList3,
        this.lists.inputList4
      ];
      allinput.forEach((input) => {
        input.forEach((item) => {
          if (item.key.indexOf("-flatK") >= 0 || item.key.indexOf("-flat-simK") >= 0) {
            item.val = paramNormal(this.mapValues.params["K1"].value, FORMAT_OPT);
          } else if (item.key.indexOf("-steepK") >= 0 || item.key.indexOf("-steep-simK") >= 0) {
            item.val = paramNormal(this.mapValues.params["K2"].value, FORMAT_OPT);
          } else if (item.key.indexOf("-w2w") >= 0) {
            item.val = paramNormal(w2w, FORMAT_OPT);
          } else if (item.key.indexOf("-e") >= 0) {
            item.val = paramNormal(this.mapValues.params["EccPEQ"].value, FORMAT_OPT);
          } else if (item.key.indexOf("-meanK") >= 0) {
            let k1 = this.mapValues.params.K1.value;
            let k2 = this.mapValues.params.K2.value;
            if (k1 !== INVALID_1000 && k2 !== INVALID_1000) {
              item.val = paramNormal((k1 + k1) / 2, FORMAT_OPT);
            }
          } else if (item.key.indexOf("-flatE") >= 0) {
            item.val = paramNormal(meanEcc.flatE, FORMAT_OPT);
          } else if (item.key.indexOf("-steepE") >= 0) {
            item.val = paramNormal(meanEcc.steepE, FORMAT_OPT);
          }
        });
      });
    },
    getMeanEcc() {
      let flatE = INVALID_1000;
      let steepE = INVALID_1000;
      let option = MAJMEDIANMODES.ecc;
      let { frontpValOfMajMeridians, isShowGrayF } = this.mapValues;
      let dataParams = new DataParams();
      let medianData =
        dataParams.getMajMedianWithoutGray(
          frontpValOfMajMeridians,
          isShowGrayF,
          this.mapValues.params["AxisFlat"].value,
          option
        ) || [];
      let index = 6;
      if (medianData.length > index) {
        flatE = (medianData[index].nas + medianData[index].temp) / 2;
        steepE = (medianData[index].inf + medianData[index].sup) / 2;
      }
      return { flatE, steepE };
    },
    getW2w() {
      let w2w = INVALID_1000;
      // let key = `content.data${this.currentEye}.pupilcorneadia.corneadia.edge.r`;
      let key = getPupilCorneadiaKey(this.record, this.currentEye);
      if (hasKey(this.record, key)) {
        let r = getKey(this.record, key);
        if (r !== INVALID_1000) {
          w2w = r * window.magecoe.pupilcornea * 2;
        }
      }
      return w2w;
    }
  },
  watch: {},
  computed: {
    inputData1Title() {
      return this.$t("langcfg.txtSphSoftContactLens");
    },
    inputData2Title() {
      return this.$t("langcfg.txtSphRGP");
    },
    inputData3Title() {
      return this.$t("langcfg.txtBackRing");
    },
    inputData4Title() {
      return this.$t("langcfg.txtDoubleBackRing");
    }
  },
  beforeDestory() {},
  destroyed() {}
};
</script>

<style lang="less">
#recomd-lens {
  .el-input__inner {
    background-color: #44444c;
    border: @normal-border; //1px solid #909399;
    color: white;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    background-color: transparent;
    color: white;
    width: 150px;
    border: none; //@normal-border; //1px solid #909399;
    border-right: 0;
    font-size: 25px;
    white-space: normal;
  }
  .el-button {
    font-size: @header-fs;
    color: white;
  }
  .btn-oprator:hover {
    color: black;
    opacity: 0.8;
  }
  .table-data {
    width: 50%;
    height: 50%;
    vertical-align: top;
    padding: 20px;
    border-bottom: @thin-border;
    border-right: @thin-border;
  }
  .table-border {
    border-top: @thin-border;
    border-left: @thin-border;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-RecomContactLens.vue